import './FieldNode.scss';
import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { mapFlowNodeType, mapReportComponentType } from '@sonar-software/sonar-ts-lib';
import { Tag, Tooltip } from 'antd';
function getFieldNode(name) {
    return (React.createElement(Tag, { icon: React.createElement(UnorderedListOutlined, null) }, name));
}
export const FieldNode = ({ name, type }) => {
    const mappedName = type ? name : mapReportComponentType(name);
    const fieldNodeBase = getFieldNode(mappedName);
    if (!type) {
        return fieldNodeBase;
    }
    const nodeType = mapFlowNodeType(type);
    return (React.createElement(Tooltip, { overlay: `${nodeType} Relationship`, placement: 'bottomLeft' }, fieldNodeBase));
};
